import { Check } from 'lucide-react';

interface BookingStepperProps {
  currentStep: number;
  steps: string[];
}

export function BookingStepper({ currentStep, steps }: BookingStepperProps) {
  return (
    <div className="mb-12">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={step} className="flex flex-1 items-center">
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`flex h-12 w-12 items-center justify-center rounded-full border-2 font-bold transition-all duration-300 ${
                    isCompleted
                      ? 'border-[#D4AF37] bg-[#D4AF37] text-black'
                      : isCurrent
                        ? 'border-[#D4AF37] bg-transparent text-[#D4AF37] shadow-[0_0_20px_rgba(212,175,55,0.5)]'
                        : 'border-gray-600 bg-transparent text-gray-600'
                  }`}
                >
                  {isCompleted ? <Check className="h-6 w-6" /> : stepNumber}
                </div>
                <span
                  className={`mt-2 text-sm font-medium ${
                    isCurrent ? 'text-[#D4AF37]' : isCompleted ? 'text-white' : 'text-gray-600'
                  }`}
                >
                  {step}
                </span>
              </div>

              {/* Connecting Line */}
              {index < steps.length - 1 && (
                <div className="mx-2 h-0.5 flex-1 bg-gray-700">
                  <div
                    className={`h-full bg-[#D4AF37] transition-all duration-500 ${
                      isCompleted ? 'w-full' : 'w-0'
                    }`}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
